module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/good/clear_items-7547b555e08dd2224d78b06f0873eca2.png";